import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { formatCurrency2 } from "utils/currencyFormat";
import { ContentTableXuaHoaDon } from "./ContentTableXuaHoaDon";
import { pushNotification } from "utils/notifications";
import { ModalHuyHoaDon } from "./ModalHuyHoaDon";
import { ModalXuatHoaDon } from "./ModalXuatHoaDon";
import HoaDonApi from "service/hoaDonApi";

const initialListData = {
  List: [],
  TotalQuantity: 0,
  TotalTienThu: 0,
  TotalTienChi: 0,
  TotalPhiKho: 0,
  TotalPhiKhac: 0,
  TotalPhiHoaHong: 0,
  TotalPhiPhat: 0,
  IsHoaHongTraGop: "0",
  IsPhiKho: 1,
  TotalValueGoc: 0,
  TotalValueLai: 0,
  TotalOtheFeeHangKy: 0,
  TotalPhiPhatDongLai: 0,
  TotalPhiDongLaiCham: 0,
  TotalPhiPhatTatToan: 0,
};

export const TableDanhSachXuatHoaDon = ({
  dataSearch,
  reloadKey,
  onPageChange,
  daDoc,
  inPhieuChi,
  inPhieuThu,
  suaPhieu,
  xoaPhieu,
  isHoaHongTraGop,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungPhiPhatDongLaiCham,
  SuDungTatToanSom,
  showStatus = false,
  showActions = true,
  enableSelection = false,
  selectedIds = [],
  onSelectedIdsChange = () => {},
  onExportSelected = () => {},
}) => {
  const [listData, setListData] = useState(initialListData);
  const [loading, setLoading] = useState(false);
  const [showHuyModal, setShowHuyModal] = useState(false);
  const [showXuatModal, setShowXuatModal] = useState(false);
  const [isBanNhapModal, setIsBanNhapModal] = useState(false);
  const [modeModal, setModeModal] = useState("xuat");
  const [localReloadKey, setLocalReloadKey] = useState(0);
  const [loadingLinkIn, setLoadingLinkIn] = useState(false);
  const [loadingDongBo, setLoadingDongBo] = useState(false);

  const handleDongBoTrangThai = async () => {
    setLoadingDongBo(true);
    try {
      const response = await HoaDonApi.capNhatTrangThaiHoaDon();
      if (response.ok) {
        pushNotification(
          "Đồng bộ trạng thái hóa đơn thành công",
          "success",
          "TOP_CENTER",
          3000,
        );
        setLocalReloadKey((k) => k + 1);
      } else {
        pushNotification(
          response.data?.Message || "Đồng bộ thất bại",
          "error",
          "TOP_CENTER",
          3000,
        );
      }
    } catch (error) {
      pushNotification(
        error.response?.data?.Message || error.message || "Lỗi khi đồng bộ",
        "error",
        "TOP_CENTER",
        3000,
      );
    } finally {
      setLoadingDongBo(false);
    }
  };

  const handleLinkIn = async () => {
    setLoadingLinkIn(true);
    try {
      const response = await HoaDonApi.linkInHoaDon(selectedIds[0].ThuChiID);
      if (response.data?.Link) {
        window.open(response.data.Link, "_blank");
      } else {
        pushNotification(
          "Không lấy được link in hóa đơn",
          "error",
          "TOP_CENTER",
          3000,
        );
      }
    } catch (error) {
      pushNotification(
        error.response?.data?.Message || error.message || "Lỗi khi lấy link in",
        "error",
        "TOP_CENTER",
        3000,
      );
    } finally {
      setLoadingLinkIn(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await HoaDonApi.listXuatHoaDon(dataSearch);
        if (response.ok) {
          setListData(response.data);
        } else {
          pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
        }
      } catch (e) {
        pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadKey, localReloadKey]);

  const handlePageChange = (pageNumber) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    onPageChange(pageNumber);
  };

  const TotalQuantity = listData.TotalQuantity;

  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
          marginTop: "-35px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new tableFix">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " + (loading ? "is-active" : "")
                }
              ></div>
            </div>
            <div className="table-mobile table-mobile-hover table-responsive-new ">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  marginBottom: "10px",
                  flexWrap: "wrap",
                  gap: "12px",
                  position: "sticky",
                  padding: "2px",
                  top: "0rem",
                  zIndex: "999",
                  background: "#FFFFFF",
                  padding: "1px 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    className="btn ml-2 btn-info-new"
                    onClick={() => {
                      setModeModal("xuat");
                      setIsBanNhapModal(false);
                      setShowXuatModal(true);
                    }}
                    disabled={
                      !selectedIds.length ||
                      selectedIds.some((item) => item.IsXuatHoaDon === 1)
                    }
                  >
                    Xuất hóa đơn
                  </button>
                  <button
                    type="button"
                    className="btn ml-2 btn-info-new"
                    onClick={() => {
                      setModeModal("xuat");
                      setIsBanNhapModal(true);
                      setShowXuatModal(true);
                    }}
                    disabled={
                      !selectedIds.length ||
                      selectedIds.some((item) => item.IsXuatHoaDon === 1)
                    }
                  >
                    Xuất bản nháp
                  </button>
                  {/* <button
                    type="button"
                    className="btn ml-2 btn-danger-new color7"
                    onClick={() => setShowHuyModal(true)}
                    disabled={selectedIds[0]?.IsXuatHoaDon !== 2}
                  >
                    Hủy hóa đơn
                  </button> */}
                  <button
                    type="button"
                    className="btn ml-2 btn-info-new"
                    onClick={() => {
                      setModeModal("thay-the");
                      setIsBanNhapModal(false);
                      setShowXuatModal(true);
                    }}
                    disabled={selectedIds[0]?.IsXuatHoaDon !== 1}
                  >
                    Thay thế hóa đơn
                  </button>
                  <button
                    type="button"
                    className="btn ml-2 btn-info-new"
                    onClick={handleLinkIn}
                    disabled={
                      loadingLinkIn ||
                      (selectedIds[0]?.IsXuatHoaDon !== 1 &&
                        selectedIds[0]?.IsXuatHoaDon !== 2)
                    }
                  >
                    {loadingLinkIn ? "Đang tải..." : "Xuất file"}
                  </button>
                </div>
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  {/* {selectedIds.length > 0 && (
                    <span className="color7">{`Đã chọn ${selectedIds.length} mục`}</span>
                  )} */}
                  <button
                    type="button"
                    className="btn ml-2 btn-info-new"
                    onClick={handleDongBoTrangThai}
                    disabled={loadingDongBo}
                  >
                    {loadingDongBo ? "Đang đồng bộ..." : "Đồng bộ"}
                  </button>
                </div>
              </div>
              <div className="custom-table-wrapper">
                <div
                  className="table-headers-v2   hidden-mobile-main "
                  style={{
                    position: "sticky",
                    padding: "2px",
                    top: "3rem",
                    zIndex: "999",
                    background: "#FFFFFF",
                    padding: "1px 0",
                  }}
                >
                  <div className="custom-table-header flex-basis-5 flex-mobile-5">
                    <p className="text-center color-do-bold">
                      STT
                      <br />
                      <span className="color-do-bold">
                        [{listData.TotalQuantity}]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-8 flex-mobile-10 center-flex">
                    <p>Thời gian</p>
                  </div>

                  <div className="custom-table-header center-flex flex-basis-9 flex-mobile-12">
                    <p>Số hóa đơn</p>
                  </div>
                  <div className="custom-table-header flex-basis-9 flex-mobile-12">
                    <p>Tên khách hàng</p>
                  </div>

                  <div className="custom-table-header flex-basis-6 flex-mobile-12">
                    <p className="text-left">Loại</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-mobile-15">
                    <p className="text-right">
                      Thu
                      <br />
                      <span
                        className="color-xanh-bold"
                        title={formatNumber(listData.TotalTienThu)}
                      >
                        {formatCurrency2(listData.TotalTienThu)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-9 flex-mobile-13">
                    <p className="text-right">
                      Phí kho
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listData.TotalPhiKho)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-9 flex-mobile-13">
                    <p className="text-right">
                      Phí khác
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(listData.TotalPhiKhac)}
                      </span>
                    </p>
                  </div>
                  {/* {(isDuDungPhiPhatDongLaiTatToan ||
                    isSuDungPhiPhatDongLaiCham) && (
                    <>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phạt chậm đóng lãi
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(listData.TotalPhiPhatDongLai)}
                          </span>
                        </p>
                      </div>
                    </>
                  )}
                  {(isDuDungPhiPhatDongLaiTatToan || SuDungTatToanSom) && (
                    <div className="custom-table-header flex-basis-9 flex-mobile-13">
                      <p className="text-right">
                        Phạt tất toán sớm
                        <br />
                        <span className="color-xanh-bold">
                          {formatNumber(listData.TotalPhiPhatTatToan)}
                        </span>
                      </p>
                    </div>
                  )} */}
                  {/* {(listData.IsHoaHongTraGop !== "0" ||
                    listData.TotalPhiPhat > 0) && (
                    <>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phí phạt
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(listData.TotalPhiPhat)}
                          </span>
                        </p>
                      </div>
                      <div className="custom-table-header flex-basis-9 flex-mobile-13">
                        <p className="text-right">
                          Phí hoa hồng
                          <br />
                          <span className="color-xanh-bold">
                            {formatNumber(listData.TotalPhiHoaHong)}
                          </span>
                        </p>
                      </div>
                    </>
                  )} */}
                  <div className="custom-table-header-thu-lai flex-basis-27 flex-mobile-39">
                    <table
                      className="content_table"
                      style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            colSpan="3"
                            style={{
                              textAlign: "center",
                              borderBottom: "1px solid #e3ebf3",
                            }}
                            className="color7-bold"
                          >
                            Thu lãi
                          </th>
                        </tr>
                        <tr>
                          <th
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Tiền gốc
                          </th>
                          <th
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Tiền lãi
                          </th>
                          <th
                            style={{
                              textAlign: "right",
                              paddingRight: "10px",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                            }}
                            className="color7-bold"
                          >
                            Các loại phí
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-cam-bold"
                          >
                            <span title={formatNumber(listData.TotalValueGoc)}>
                              {formatNumber(listData.TotalValueGoc)}
                            </span>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-xanh-bold"
                          >
                            <span title={formatNumber(listData.TotalValueLai)}>
                              {formatNumber(listData.TotalValueLai)}
                            </span>
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              border: "1px solid #e3ebf3",
                              width: "33.33%",
                              fontSize: "13px",
                            }}
                            className="color-do-bold"
                          >
                            <span
                              title={formatNumber(listData.TotalOtheFeeHangKy)}
                            >
                              {formatNumber(listData.TotalOtheFeeHangKy)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {showStatus && (
                    <div className="custom-table-header flex-basis-9 flex-mobile-8 action-cell">
                      <p className="tab-header">Trạng thái</p>
                    </div>
                  )}
                  {showActions && (
                    <div className="custom-table-header flex-basis-9 flex-mobile-8 action-cell">
                      <p className="tab-header">Chức năng</p>
                    </div>
                  )}
                </div>
                <div className="custom-table-body ">
                  <ContentTableXuaHoaDon
                    listQuanLyThuChiHopDong={listData.List}
                    daDoc={daDoc}
                    inPhieuChi={inPhieuChi}
                    inPhieuThu={inPhieuThu}
                    suaPhieu={suaPhieu}
                    xoaPhieu={xoaPhieu}
                    isHoaHongTraGop={isHoaHongTraGop}
                    isDuDungPhiPhatDongLaiTatToan={
                      isDuDungPhiPhatDongLaiTatToan
                    }
                    isSuDungPhiPhatDongLaiCham={isSuDungPhiPhatDongLaiCham}
                    SuDungTatToanSom={SuDungTatToanSom}
                    showStatus={showStatus}
                    showActions={showActions}
                    selectedIds={selectedIds}
                    onSelectedIdsChange={onSelectedIdsChange}
                    dataSearch={dataSearch}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
          marginTop: "-25px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity,
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showXuatModal && (
        <ModalXuatHoaDon
          show={showXuatModal}
          onHide={() => setShowXuatModal(false)}
          item={selectedIds[0]}
          isBanNhap={isBanNhapModal}
          mode={modeModal}
          onSuccess={() => setLocalReloadKey((k) => k + 1)}
        />
      )}
      {showHuyModal && (
        <ModalHuyHoaDon
          show={showHuyModal}
          onHide={() => setShowHuyModal(false)}
          thuChiId={selectedIds[0]?.ThuChiID}
        />
      )}
    </>
  );
};
